import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingServiceRequestSetType,
    getServiceRequestSetTypeById,
    saveOrUpdateServiceRequestSetType,
    deleteServiceRequestSetType
} from 'app/services/ServiceRequestSetTypeService';

import { ServiceRequestSetType } from "app/common/Model/ServiceRequestSetType";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { PAGESIZE_ALL } from "app/common/LocalConst";

export default class ServiceRequestSetTypeStore {
    listAllServiceRequestSetType = [];
    searchServiceRequestSetType = new SearchObject();
    pageServiceRequestSetType = null;
    selectedServiceRequestSetType = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteServiceRequestSetType = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllServiceRequestSetType = () => {
        if (this.listAllServiceRequestSetType?.length === 0 || this.recentlyUpdated) {
            pagingServiceRequestSetType({ pageIndex: 1, pageSize: PAGESIZE_ALL })
                .then(({ data }) => {
                    this.listAllServiceRequestSetType = data?.content || [];
                    this.recentlyUpdated = false;
                })
                .catch(error => {
                    console.error(error);
                    toast.error("Lấy dữ liệu loại bộ dịch vụ có lỗi");
                });
        }
    }

    pagingServiceRequestSetType = async () => {
        return await pagingServiceRequestSetType(this.searchServiceRequestSetType)
            .then(({ data }) => {
                this.pageServiceRequestSetType = data;
            })
            .catch(error => {
                console.error(error);
                toast.error("Lấy dữ liệu loại bộ dịch vụ có lỗi");
            });
    }

    handleChangeFormSearch = (searchServiceRequestSetType) => {
        this.searchServiceRequestSetType = checkSearchObject(this.searchServiceRequestSetType, searchServiceRequestSetType);
        this.pagingServiceRequestSetType();
    }

    handleOpenFormCreateOrEdit = (serviceRequestSetTypeId) => {
        if (Boolean(serviceRequestSetTypeId)) {
            getServiceRequestSetTypeById(serviceRequestSetTypeId).then(({ data }) => {
                this.selectedServiceRequestSetType = data;
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedServiceRequestSetType = new ServiceRequestSetType();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceRequestSetType = async (serviceRequestSetType, { setSubmitting }) => {
        return await saveOrUpdateServiceRequestSetType(serviceRequestSetType).then(() => {
            this.selectedServiceRequestSetType = null;
            toast.success("Lưu loại bộ dịch vụ thành công!");
            this.pagingServiceRequestSetType();
            this.handleClosePopup();
            this.listAllServiceRequestSetType = [];
            this.recentlyUpdated = true;
        }).catch(function (error) {
            toast.error("Lưu loại bộ dịch vụ thất bại!");
            console.error(error);
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteServiceRequestSetType = (serviceRequestSetType) => {
        this.selectedServiceRequestSetType = { id: serviceRequestSetType?.id };
        this.openConfirmDeleteServiceRequestSetType = true;
    }

    handleConfirmDeleteServiceRequestSetType = () => deleteServiceRequestSetType(this.selectedServiceRequestSetType?.id)
        .then(() => {
            if (this.searchServiceRequestSetType?.pageIndex > 1 && this.pageServiceRequestSetType?.content?.length === 1) {
                this.searchServiceRequestSetType.pageIndex -= 1;
            }
            toast.success("Xóa loại bộ dịch vụ thành công!");
            this.pagingServiceRequestSetType();
            this.handleClosePopup();
            this.recentlyUpdated = true;
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa loại bộ dịch vụ thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceRequestSetType = false;
    }

    resetStore = () => {
        this.searchServiceRequestSetType = new SearchObject();
        this.pageServiceRequestSetType = null;
        this.selectedServiceRequestSetType = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceRequestSetType = false;
    }
}